import React, { useEffect, useState } from "react";
import { Switch, Redirect } from "react-router-dom";
import dotenv from "dotenv";
dotenv.config();

export default function AuthorizePage() {
  const [isLoading, setLoading] = useState(true);
  debugger;
  window.sessionStorage.setItem("ingressPath", window.location.pathname);

  useEffect(() => {
    debugger;
    window.location.href = process.env.REACT_APP_GET_TOKEN_ID_ENDPOINT;
  }, []);

  if (isLoading) {
    return <div className="App">Loading...</div>;
  }

  return (
    <>
      <Switch>
        <Redirect to="/authorize" />
      </Switch>
      <div className="loading-container"></div>
      <div className="loading-widget">
        <div className="loading-img"></div>
      </div>
    </>
  );
}
